import React, { useMemo, useState } from "react";
import axios from "axios";
import apiUrl from "../Apiurl";

function normalizedCodes(value) {
  return Array.from(new Set(String(value || "").split(/[\s,;]+/).map((entry) => entry.trim()).filter(Boolean)));
}

export default function PrestashopAlignmentBatchPreview({ token, canWrite, onCreated }) {
  const [direction, setDirection] = useState("VIG_TO_BOT");
  const [codes, setCodes] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const codVS = useMemo(() => normalizedCodes(codes), [codes]);
  const tooMany = codVS.length > 20;
  const expected = direction === "VIG_TO_BOT" ? "pubblicato = SI" : "pubblicato = NO o PROBLEMA";

  const submit = async (event) => {
    event.preventDefault();
    if (!canWrite || !codVS.length || tooMany) return;
    setBusy(true);
    setError("");
    setResult(null);
    try {
      const response = await axios.post(apiUrl + "/moda/prestashop-alignment/runs/preview", {
        codVS,
        direction,
        filters: { source: "MANUAL_CODVS", pubblicato: expected },
      }, { headers: { Authorization: "Bearer " + token } });
      const data = response?.data?.data || null;
      setResult(data);
      if (onCreated) await onCreated(data);
    } catch (requestError) {
      const code = requestError?.response?.data?.code;
      const message = requestError?.response?.data?.error || requestError?.message || "Batch preview non creato.";
      setError(code ? message + " (" + code + ")" : message);
    } finally { setBusy(false); }
  };

  return (
    <section className="alignment-batch-preview br3 pa3 mb3 sfondoBiancoTema" aria-labelledby="alignment-batch-title">
      <div className="alignment-batch-heading">
        <div>
          <h2 id="alignment-batch-title" className="f5 mt0 mb1">Nuova batch preview</h2>
          <p className="f7 mt0 mb0 scrittaColMedia">Analizza in sequenza fino a 20 articoli. Non approva e non applica modifiche.</p>
        </div>
        <span className="alignment-badge alignment-badge--muted">Priorita inferiore alle analisi manuali</span>
      </div>
      <form className="alignment-batch-form mt3" onSubmit={submit}>
        <label className="f7">
          <span className="db mb1">Direzione</span>
          <select aria-label="Direzione batch" className="w-100 pa2" value={direction} onChange={(event) => setDirection(event.target.value)} disabled={busy || !canWrite}>
            <option value="VIG_TO_BOT">VIG → BOT</option>
            <option value="BOT_TO_VIG">BOT → VIG / Moda</option>
          </select>
          <small className="db mt1 scrittaColMedia">Selezione ammessa: {expected}</small>
        </label>
        <label className="f7 alignment-batch-codes">
          <span className="db mb1">Codici VS</span>
          <textarea aria-label="Codici VS" rows="4" className="w-100 pa2" value={codes} onChange={(event) => setCodes(event.target.value)} disabled={busy || !canWrite} placeholder="Un codice per riga, massimo 20" />
          <small className={tooMany ? "db mt1 alignment-block-reason" : "db mt1 scrittaColMedia"}>{codVS.length}/20 codici univoci</small>
        </label>
        <div className="alignment-batch-submit">
          <button type="submit" className="alignment-button alignment-button--primary" disabled={!canWrite || busy || !codVS.length || tooMany}>
            {busy ? "Creazione batch" : "Avvia batch preview"}
          </button>
        </div>
      </form>
      {!canWrite ? <p className="alignment-block-reason mb0 mt2">Permessi update:prestashop e write:debug richiesti per creare una run.</p> : null}
      {result ? (
        <div className="alignment-batch-result mt3" role="status">
          <strong>Run {result.runId}</strong>
          <span>{result.selectedCodVS?.length || 0} articoli accodati</span>
          {!result.workerEnabled ? <span className="alignment-block-reason">Worker sospeso: VSTRANSLATIONAPI_ENABLE_CRON_IMPORT non e attivo.</span> : null}
          {Array.isArray(result.excluded) && result.excluded.length ? (
            <details className="mt2"><summary>{result.excluded.length} codici esclusi</summary>
              <ul className="f7 lh-copy mb0">{result.excluded.map((entry) => <li key={entry.codVS}><strong>{entry.codVS}</strong>: {entry.message}</li>)}</ul>
            </details>
          ) : null}
        </div>
      ) : null}
      {error ? <p role="alert" className="alignment-block-reason mb0 mt2">{error}</p> : null}
    </section>
  );
}
